/* How to create a character: the creation steps' rules text (content/steps.tsx), shown under the roster
   as the page's guide, the way the Character Creation page read before the builder. */

import steps from './content/steps';

export default function CreationGuide() {
  return (
    <section className="cc-guide" aria-labelledby="cc-guide-title">
      <div className="cc-roster__head">
        <h2 id="cc-guide-title" className="cc-roster__title">How to create a character</h2>
      </div>
      <div className="cc-guide__intro">
        <p>
          Each player creates their own PC by making a series of guided choices. Some decisions are purely narrative - they
          only appear in your character guide or affect the game through roleplaying. Others are mechanical choices that affect
          what your PC can do and how likely they are to succeed.
        </p>
        <p className="cc-guide__note">
          <strong>Note:</strong> You can fill in your character's name, pronouns, and Character Description details at any point
          during the character creation process.
        </p>
      </div>
      <ol className="cc-guide__steps">
        {steps.map((s) => (
          <li key={s.step} className="cc-guide__step">
            <div className="cc-guide__rail" aria-hidden="true">
              <span className="cc-guide__num">{s.step}</span>
              <span className="cc-guide__spine" />
            </div>
            <div className="cc-guide__body">
              <h3 className="cc-guide__title">{s.title}</h3>
              <div className="cc-guide__desc">{s.description}</div>
              <div className="cc-guide__details">{s.details}</div>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}
